import type React from "react";
import {useNavigate, useParams} from "react-router-dom";

import {useDeletePlaylist} from "~/api/hooks/useDeletePlaylist";
import {usePlaylist} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";

import ButtonSpinner from "../../../../component/spinner/ButtonSpinner";

interface DeletePlaylistContentProps {
  closeModal: () => void;
}

const DeletePlaylistContent: React.FC<DeletePlaylistContentProps> = ({
  closeModal,
}) => {
  const {playlistId} = useParams<{playlistId: string}>();
  const {data: playlist} = usePlaylist({id: playlistId});
  const navigate = useNavigate();

  const {mutateAsync: deletePlaylist, isPending: isDeleting} =
    useDeletePlaylist();

  const handleDelete = async () => {
    if (!playlistId) return;

    try {
      await deletePlaylist({data: {id: playlistId}}).then(() =>
        navigate("/play"),
      );
    } catch (error) {
      console.error("Error deleting playlist:", error);
    }
  };

  return (
    <div className="w-full text-white">
      <h2 className="text-2xl mb-4">Delete Playlist</h2>
      <p className="mb-6">
        Are you sure you want to delete "{playlist?.name}"? This action cannot
        be undone.
      </p>
      <div className="flex justify-end space-x-4">
        <CustomButton
          className="bg-gray-500 hover:bg-gray-700 text-white py-2 px-4 rounded"
          onClick={closeModal}
        >
          Cancel
        </CustomButton>
        <CustomButton
          className="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          <ButtonSpinner isLoading={isDeleting} />
          Delete
        </CustomButton>
      </div>
    </div>
  );
};

export default DeletePlaylistContent;
